// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistant-message-pop-ZDsN0I{background:#fff;border-radius:16px;margin:0 auto 20px 52px;padding:16px}@keyframes generating-dot-animation-TReaxe{0%{background-color:#2e3238}50%{background-color:#a7abb0}to{background-color:#2e3238}}.top-safe-area-MLzarH{padding:12px}.bottom-safe-area-vQBoIG{padding:32px}.scroll-mask-IqKwxo{-webkit-mask:linear-gradient(#fff 91.89%,rgba(255,255,255,0) 100%);mask:linear-gradient(#fff 91.89%,rgba(255,255,255,0) 100%)}.mask-scroll-header-top-l2T2fA{pointer-events:none;z-index:100;background:linear-gradient(rgba(0,0,0,.32) 0%,transparent 100%);width:100%;height:60px;position:absolute;top:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"assistant-message-pop": `assistant-message-pop-ZDsN0I`,
	"assistantMessagePop": `assistant-message-pop-ZDsN0I`,
	"top-safe-area": `top-safe-area-MLzarH`,
	"topSafeArea": `top-safe-area-MLzarH`,
	"bottom-safe-area": `bottom-safe-area-vQBoIG`,
	"bottomSafeArea": `bottom-safe-area-vQBoIG`,
	"scroll-mask": `scroll-mask-IqKwxo`,
	"scrollMask": `scroll-mask-IqKwxo`,
	"mask-scroll-header-top": `mask-scroll-header-top-l2T2fA`,
	"maskScrollHeaderTop": `mask-scroll-header-top-l2T2fA`,
	"generating-dot-animation": `generating-dot-animation-TReaxe`,
	"generatingDotAnimation": `generating-dot-animation-TReaxe`
};
export default ___CSS_LOADER_EXPORT___;
